<template>
 <div>
  <div class="bg-facebook border-bottom small py-2 pr-0">
    <div class="container d-flex justify-content-end">
      <div class="row justify-content-start">
        <div class="col text-left">
        <span dir="ltr" class="text-white text-big">
            <i class="ui-icon ui-icon-sm ion lnr lnr-phone-handset" style="border-color:#fff;border:solid 1px;"></i>
          + (218) 92-2441623
        </span>

        <span dir="ltr" class="text-white ml-3 text-big">
            <i class="ui-icon ui-icon-sm far fa-envelope-open" style="border-color:#fff;border:solid 1px;"></i>
         <a href="mailto:info@al-tarik.ly" class="text-white">info@al-tarik.ly</a>
        </span>

        <a href="https://www.facebook.com/Altarek.Hospital" target="_blank"
        class="ui-icon ui-icon-sm fab fa-facebook-f text-white ml-3 text-big" style="border-color:#fff;border:solid 1px;">
        </a>

        <!-- <b-link v-if="$store.state.authenticated" class="text-white ml-3 text-big" to="/dashboard">لوحة الرئيسية</b-link> -->
      </div>
      </div>
    </div>
  </div>
   <!-- Nav -->
 <nav class="navbar navbar-expand-lg border-bottom bg-white1" style="background-color:#fff;">
  <div class="container">

    <b-link to="/home">
      <img :src="`${publicUrl}img/logos/logo.png`" width="110" alt="" class="mr-1">
    </b-link>
    <b-link to="/home" class="navbar-brand text-large font-weight-bolder line-height-1 py-3 text-facebook">
      <div class="mb-2">
        مستشفى الطارق
      </div>
     <div class="text-flickr">
        معنا للحياة معنى
     </div>
    </b-link>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#header-3">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="header-3">
      <b-navbar-nav class="text-big font-weight-bold ml-auto">
        <b-nav-item to="/home">الرئيسية</b-nav-item>
        <b-nav-item  to="/about">عن المستشفى</b-nav-item>
        <b-nav-item to="/news">الاخبار و المقالات</b-nav-item>
        <b-nav-item to="/timetables">مواعيد العيادات التخصصيه</b-nav-item>
        <b-nav-item to="/contact">لتواصل معنا</b-nav-item>
      </b-navbar-nav>
    </div>

  </div>
</nav>

  <!-- / Nav -->
</div>
</template>

<style>
#blog-subnav-wrapper {
    position: relative;
}
.btn-custom {
    border-color: rgb(255 255 255);
    background: transparent;
    color: #4E5155;
}
.icon-btn-top {
    width: calc(2rem + 2px);
    padding: 0;
    line-height: 2rem;
}
.header-top-area-dark {
    background: #60646d;
}

a.router-link-active {
  color: #f66;
}
li.router-link-active a {
  color: #f66;
}
</style>
<style src="@/vendor/libs/spinkit/spinkit.scss" lang="scss"></style>

<script>
import Vue from 'vue'
import BlockUI from 'vue-blockui'
import axios from 'axios'
import ToastPlugin from 'bootstrap-vue'
Vue.use(BlockUI)
Vue.use(ToastPlugin)

export default {
  name: 'app-layout-navbar',

  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      profile: {},
      bs4Toasts: {
        variant: null,
        avatar: 'img/avatars/1.png',
        title: 'Default',
        time: '11 mins ago',
        message: 'Hello, world! This is a toast message.'
      },

      isBusy: false,
      // html:null,
      html: `
      <div class="sk-wave sk-primary">
        <div class="sk-rect sk-rect1"></div>
              <div class="sk-rect sk-rect2"></div>
              <div class="sk-rect sk-rect3"></div>
              <div class="sk-rect sk-rect4"></div>
              <div class="sk-rect sk-rect5"></div>    
        </div>
      <h5 class="text-center mb-0">Searching...</h5>`,
      keywords: ''
    }
  },

  computed: {
    user () {
      return this.$store.state.user
    }
  },
  created () {

  },

  mounted () {
    this.getProfile()
  },

  watch: {

  },

  methods: {
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },

    getLayoutNavbarBg () {
      return this.layoutNavbarBg
    },

    getProfile () {
      axios.get('/api/user').then(res => {
        const user = res.data
        this.$store.state.user = user
      })
    },

    showToastMessage (variant = null) {
      // ToastPlugin.toast
      this.$bvToast.toast('Toast body content', {
        title: `Variant ${variant || 'default'}`,
        variant: variant,
        solid: true
      })
    },

    async logout () {
      await axios.get('/sanctum/csrf-cookie').then(res => {
        axios.post('/logout')
        console.log('Saad')
        localStorage.removeItem('userToken')
        location.reload()
      })
    }
  }
}
</script>
